module.exports = __webpack_public_path__ + "img/pinnacle.15b4de8b.png";